<template>
  <div>
    <div class="w-100">
      <v-row class="mb-10">
        <v-col cols="12">
          <v-data-table
            @change="$emit('input', value)"
            :headers="aditionalsHeaders"
            :items="value"
            :items-per-page="value.length"
            no-data-text="Nenhum adicional adicionado"
            hide-default-footer
          >
            <template v-slot:[`item.boardingId`]="{ item }">
              <span>
                {{ getBoardingOrStopId(item.boardingId) }}
              </span>
            </template>
            <template v-slot:[`item.stopId`]="{ item }">
              <span>
                {{ getBoardingOrStopId(item.stopId) }}
              </span>
            </template>
            <template v-slot:[`item.additionalDate`]="{ item }">
              <span>
                {{ formatDate(item.additionalDate) }}
              </span>
            </template>
            <template v-slot:[`item.isDiscount`]="{ item }">
              <span>
                {{ getDiscountText(item.isDiscount) }}
              </span>
            </template>
            <template v-slot:[`item.price`]="{ item }">
              <span>
                {{ formatPrice(item.price) }}
              </span>
            </template>
            <template v-slot:[`item.justification`]="{ item }">
              <span>
                {{ getJustificationName(item.justification) }}
              </span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex justify-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" @click="removeAditional(item)" icon color="red" dark>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { VMoney } from 'v-money';
import { mapActions } from 'vuex';
import maskPrice from '@/utils/maskPrice';
export default {
  props: {
    value: {
      default: () => [],
      type: Array
    },
    restrictedBoardingOrStopIds: {
      default: () => [],
      type: Array
    },
    isTranshipmentAditionals: {
      default: false,
      type: Boolean
    },
    creditsOnly: {
      default: false,
      type: Boolean
    }
  },
  directives: { money: VMoney },
  data: () => ({
    boardingOrStopId: null,
    aditional: {
      isDiscount: null,
      price: null,
      justification: null,
      additionalDate: null,
      observation: null,
      boardingId: null,
      stopId: null
    },
    aditionals: [],
    justifications: [],
    aditionalType: [
      { text: 'Crédito', value: false },
      { text: 'Débito', value: true }
    ],

    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      aditionalType: (value) => value !== null || 'Campo obrigatório!',
      hasPrice: (value) => {
        return value !== 'R$ 0,00' || 'Campo obrigatório!';
      },
      isValidId: (value) => {
        const hasValidGuid =
          value !== null && value.length === 36 && /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/.test(value);

        if (value === null || value === '') {
          return true;
        } else if (hasValidGuid) {
          return true;
        } else {
          return 'ID inválido!';
        }
      }
    },
    menu: false
  }),

  computed: {
    aditionalsHeaders() {
      return [
        {
          value: this.isTranshipmentAditionals ? 'stopId' : 'boardingId',
          text: this.isTranshipmentAditionals ? 'ID DA PARADA' : 'ID DO EMBARQUE'
        },
        {
          value: 'isDiscount',
          text: 'TIPO'
        },
        {
          value: 'price',
          text: 'VALOR'
        },
        {
          value: 'additionalDate',
          text: 'DATA'
        },
        {
          value: 'justification',
          text: 'JUSTIFICATIVA'
        },
        {
          value: 'observation',
          text: 'OBSERVAÇÃO'
        },
        {
          value: 'actions',
          sortable: false,
          align: 'end',
          text: ''
        }
      ];
    },
    formattedDate() {
      const date = this.aditional.additionalDate;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    boardingOrStopIdLabel() {
      return this.isTranshipmentAditionals ? 'ID da Parada' : 'ID do Embarque';
    },

    boardingOrStopIdNoDataText() {
      return `Digite um id de ${this.isTranshipmentAditionals ? 'parada' : 'embarque'} disponível`;
    },

    isTransferAditionals() {
      return this.restrictedBoardingOrStopIds.length !== 0;
    },
    isDiscountItems() {
      return this.creditsOnly ? [{ text: 'Crédito', value: false }] : this.aditionalType;
    },
    shouldDisableJustification() {
      return this.aditional.isDiscount === null;
    }
  },

  methods: {
    ...mapActions('NfeStore', ['fetchJustificationsById']),

    addAditional() {
      const boardingOrStopId = this.boardingOrStopId ? this.boardingOrStopId : null;

      const aditionals = [
        ...this.value,
        {
          ...this.aditional,
          justification: this.aditional.justification,
          price: this.transformPriceToSend(this.aditional.price),
          boardingId: !this.isTranshipmentAditionals ? boardingOrStopId : null,
          stopId: this.isTranshipmentAditionals ? boardingOrStopId : null
        }
      ];
      this.$emit('input', aditionals);
    },

    removeAditional(aditional) {
      if (aditional.isRelatedAditional) {
        this.$emit('relatedAditionalRemove', aditional);
      }

      const aditionalIndex = this.value.indexOf(aditional);
      const aditionals = this.value;
      aditionals.splice(aditionalIndex, 1);

      this.$emit('input', aditionals);
    },

    getBoardingOrStopId(boardingOrStopId) {
      return boardingOrStopId ? boardingOrStopId : ' - ';
    },

    getDiscountText(isDiscount) {
      return isDiscount ? 'Débito' : 'Crédito';
    },

    getJustificationName(justification) {
      return typeof justification === 'string' ? justification : justification.name;
    },

    formatPrice(price) {
      return maskPrice(price);
    },

    formatDate(date) {
      const [year, month, day] = date.slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },

    transformPriceToSend(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__slot {
  margin: 0;
  padding: 0;

  &::after,
  &::before {
    display: none !important;
  }
}
::v-deep.v-input {
  .v-text-field {
    &__details {
      padding-top: 4px;
      display: inline-block;
    }
  }
}
</style>
